import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import TopRank from "./components/TopRank";
import HighScore from "./components/HighScore";
import Genres from "./components/Genres";
import NewReleases from "./components/NewReleases";
import Classics from "./components/Classics";
import Testimonials from "./components/Testimonials";
import Faq from "./components/Faq";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Navbar />
      <main>
        <Hero />
        <TopRank />
        <HighScore />
        <Genres />
        <NewReleases />
        <Classics />
        <Testimonials />
        <Faq />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}